import Auth from './auth';

export default Auth;


// WEBPACK FOOTER //
// ./src/service/auth/index.js